import { Box } from '@mui/material'
import { useState, ChangeEvent, KeyboardEvent } from 'react'

type LabelValue = {
  label: string
  value: string
}

type Props = {
  items: LabelValue[]
  onSearch: (query: string, param: string) => void
  placeHolder?: string
}

export const ProrithmSelectableSearch = ({
  items,
  onSearch,
  placeHolder,
}: Props) => {
  const [value, setValue] = useState<string>('')
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const [activeIndex, setActiveIndex] = useState<number>(0)

  const handleOnInput = () => setIsEditing(true)
  const handleOnBlur = () => setIsEditing(false)

  const handleOnChange = (ev: ChangeEvent<HTMLInputElement>) => {
    const inputValue = ev.target.value
    setValue(inputValue)
    if (!inputValue) {
      onSearch('', '')
    }
  }

  const handleSelect = (param: number) => {
    const selected = items?.[param]
    if (selected) {
      setActiveIndex(0)
      setIsEditing(false)
      onSearch(value, selected.value)
    }
  }

  const handleKeyDown = (ev: KeyboardEvent<HTMLInputElement>) => {
    const size = items?.length || 0
    switch (ev.key) {
      case 'Tab':
      case 'Enter':
        handleSelect(activeIndex)
        ev.preventDefault()
        break
      case 'ArrowUp':
        setActiveIndex((prev) => (prev + size - 1) % size)
        ev.preventDefault()
        break
      case 'ArrowDown':
        setActiveIndex((prev) => (prev + 1) % size)
        ev.preventDefault()
        break
    }
  }

  return (
    <Box marginY={1} className='selectable-search-wrapper'>
      <input
        data-testid='selectable-search-input'
        placeholder={placeHolder ?? 'Search by Patient UHID'}
        className='search-input'
        type='search'
        value={value}
        onBlur={handleOnBlur}
        onInput={handleOnInput}
        onClick={handleOnInput}
        onChange={handleOnChange}
        onKeyDown={handleKeyDown}
      />
      {isEditing && value && (
        <div className='options-wrapper'>
          {items?.map((item, idx) => (
            <p
              key={item?.value}
              onMouseEnter={() => setActiveIndex(idx)}
              onMouseDown={() => handleSelect(idx)}
              className={`select-option${idx === activeIndex ? ' active' : ''}`}
            >
              Search {item?.label} for{' '}
              <span className='select-value'>{value}</span>
            </p>
          ))}
        </div>
      )}
    </Box>
  )
}
